import { Col, Grid } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { Button } from '@savgroup-front-common/core/atoms/button';
import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $SelectContainerGrid = styled(Grid)`
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const $SelectContainerRow = styled('div')`
  display: flex;
  flex-direction: row-reverse;
`;

export const $ColWithoutGutter = styled(Col)`
  && {
    background-color: ${({ theme }) => theme.colors.white};
    ${mediaQuery.sm`
    padding-left: ${spacing('sm')};
    padding-right: ${spacing('sm')};
  `};
  }
`;
export const $BackButtonContainer = styled($ColWithoutGutter)`
  position: relative;
  z-index: 0;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};
  padding-left: ${spacing('lg')};
  display: flex;
  justify-content: end;
  margin-bottom: ${spacing('lg')};
`;
export const $CloseButton = styled(Button)`
  padding: 0;
`;
export const $AddressContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};
  margin-top: ${spacing(11)};
`;

export const $ColMapContainer = styled(Col)`
  width: 100%;
  padding-left: unset;
  padding-right: unset;
`;

export const $ColListContainer = styled(Col)`
  height: 100vh;
  width: 100%;
  padding: ${spacing(3.5)};
  overflow: scroll;

  [class*='RadioCardWithCheckboxColumnstyles__RadioCardContainer'] {
    padding: ${spacing(5)} ${spacing('lg')};
  }

  [class*='ChooseItemCardstyles__ItemContentTextWrapper'] {
    padding-right: ${spacing('lg')};
  }

  [class*='ChooseItemCardstyles__ItemTitle'] {
    font-weight: 700;
    ${fontStyle('sm')};
  }

  [class*='ChooseItemCardstyles__ItemDescription'] {
    font-weight: ${fontWeight('normal')};
    ${fontStyle('sm')};
  }
`;

export const $NoPickupPoint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(7)} ${spacing(3.5)};
`;
